<template>
  <div class="page">
    <wk-search
      class="wrapBox"
      :search-control-data="searchControlData"
      @search="search($event)"
    ></wk-search>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div style="line-height: 40px">共{{total}}条数据</div>
        <el-button class="common-button" v-auth="permission.BANNER_ACTION_ADD" type="primary" @click="addBanner">
          添加banner
        </el-button>
      </div>
      <el-table
        class="tableBox"
        :data="tableData"
        stripe
        v-auth="permission.BANNER_ACTION_LIST"
        style="width: 100%">
        <el-table-column
          width="60"
          align="center"
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="主题">
        </el-table-column>
        <el-table-column
          width="70"
          prop="picUrl"
          label="缩略图">
          <template slot-scope="scope">
            <el-image
              alt="banner缩略图"
              style="width: 50px; height: 40px;display:block"
              :src="scope.row.picUrl">
              <template slot="error">
                <svg-icon class="error-icon" svg-name="加载失败"></svg-icon>
              </template>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="位置">
          <template slot-scope="scope">
            <span>{{scope.row.type == 1?'首页':'资讯动态'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="link"
          label="链接">
        </el-table-column>
        <el-table-column
          align="center"
          prop="startTime"
          label="开始时间">
          <template slot-scope="scope">
            <span>{{ scope.row.startTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="endTime"
          label="结束时间">
          <template slot-scope="scope">
            <span>{{ scope.row.endTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          width="80"
          label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.state == 1?'启用':'关闭'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          v-if="userInfo.roleName != '普通账号'"
          label="操作">
          <template slot-scope="scope">
            <el-button v-auth="permission.BANNER_ACTION_EDIT" class="color-blue link-button" type="text"
                       @click="editBanner(scope.row.id)">编辑
            </el-button>
            <el-button v-auth="permission.BANNER_ACTION_SWITCH" class="color-blue link-button" type="text"
                       @click="changeStatus(scope.row)">{{scope.row.state == '1'?'关闭':'开启'}}
            </el-button>
            <el-button v-auth="permission.BANNER_ACTION_DELETE" class="color-blue link-button" type="text"
                       @click="deleteClick(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchFormData.perPage"
          :current-page="searchFormData.page"
          layout="total, prev, pager, next, sizes"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <info ref="modalRef" @search="search"></info>
  </div>
</template>
<script>
  import info from "./dialogs/info";

  export default {
    components: {info},
    data() {
      return {
        total: 0,
        dialogVisible: false,
        loading: false,
        searchFormData: {
          page: 1,
          perPage: 10,
        },
        searchControlData: [
          {
            type: 'input',
            label: '主题',
            placeholder: '请输入主题',
            key: 'title'
          },
          {
            type: 'rangDate',
            label: '选择时间',
            key: 'rangDate'
          },
          {
            type: 'select',
            label: '位置',
            placeholder: '请选择位置',
            key: 'type',
            option: [
              {
                label: '全部',
                value: ''
              },
              {
                label: '首页',
                value: 1
              },
              {
                label: '资讯动态',
                value: 2
              },
            ]
          },
          {
            type: 'select',
            label: '状态',
            placeholder: '请选择状态',
            key: 'state',
            option: [
              {
                label: '全部',
                value: ''
              },
              {
                label: '开启',
                value: '1'
              },
              {
                label: '关闭',
                value: '2'
              },
            ]
          }
        ],
        tableData: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.getters["accountStore/getUserInfo"]; //获取用户信息
      }
    },
    created() {
      this.search()
    },
    methods: {
      search(data) {
        this.loading = true
        if (data) {
          Object.assign(this.searchFormData, data)
          this.searchFormData.startTime = data.rangDate ? data.rangDate[0] : ''
          this.searchFormData.endTime = data.rangDate ? data.rangDate[1] : ''
          this.searchFormData.page = 1
        }
        this.$apis.bannerServer.queryList(this.searchFormData).then(res => {
          if (res['code'] == 0 && res.data.data) {
            this.total = res.data.total
            this.tableData = res.data.data
          } else {
            this.total = 0
            this.tableData = []
          }
          this.loading = false
        })
      },
      addBanner() {
        this.$refs.modalRef.show('add')
      },
      editBanner(id) {
        this.$refs.modalRef.loadData(id)
        this.$refs.modalRef.show('edit')
      },
      changeStatus(data) {
        // state: banner的当前状态： 1：开启；2：关闭
        if (data.state == '1') {
          this.$confirm('确定关闭该banner?', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'cancelButton',
            confirmButtonClass: 'confirmButton',
            center: true
          }).then(() => {
            this.$apis.bannerServer.updateStateDisable({
              id: data.id
            }).then(res => {
              if (res['code'] == 0) {
                this.search()
                this.$message({
                  type: 'success',
                  message: '关闭成功!'
                });
              }
            })
          })
        } else {
          this.$confirm('确定启用该banner?', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'cancelButton',
            confirmButtonClass: 'confirmButton',
            type: 'info ',
            center: true
          }).then(() => {
            this.$apis.bannerServer.updateStateEnable({
              id: data.id
            }).then(res => {
              if (res['code'] == 0) {
                this.search()
                this.$message({
                  type: 'success',
                  message: '启用成功!'
                });
              }
            })
          })
        }
      },
      deleteClick(id) {
        this.$confirm('确定删除该banner', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancelButton',
          confirmButtonClass: 'confirmButton',
          type: 'info ',
          center: true
        }).then(() => {
          this.$apis.bannerServer.deleteBanner({
            id: id
          }).then(res => {
            if (res['code'] == 0) {
              this.search()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        })
      },
      handleSizeChange(val) {
        this.searchFormData.perPage = val
        this.search()
      },
      handleCurrentChange(val) {
        this.searchFormData.page = val
        this.search()
      }
    }
  }
</script>
<style>
  .el-message-box--center .el-message-box__message {
    font-size: 20px;
    color: #000000;
  }

  .cancelButton {
    width: 98px;
    margin-left: 14px;
  }

  .confirmButton {
    width: 98px;
  }
</style>
<style scoped lang="scss">
  .el-message-box--center .el-message-box__message {
    font-size: 20px;
    color: #000000;
  }
  .page {
  }
</style>
